import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { formatNullableString, toNullableLocaleDateTimeString } from '../utilities';
import { QuoteRequestResponse } from '../apiModels/quoteRequestResponse';
import { quoteContactMethods } from '../apiModels/quoteContactMethod';
import { ShipmentUpdateModel } from '../apiModels/shipmentUpdateModel';

export default function ShipmentUpdateDetailsModal(props: { show: boolean, setShow: (show: boolean) => void, shipmentUpdate: ShipmentUpdateModel }) {
    return (
        <>
            <Modal show={props.show} onHide={() => props.setShow(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Shipment Tracking Update - Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-6">
                            <label className="fw-bold">Shipment Tracking Number</label>
                            <p>{props.shipmentUpdate.shipmentTrackingNumber}</p>
                        </div>

                        <div className="col-6">
                            <label className="fw-bold">Description</label>
                            <p>{formatNullableString(props.shipmentUpdate.description)}</p>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-6">
                            <label className="fw-bold">Location</label>
                            <p>{formatNullableString(props.shipmentUpdate.location)}</p>
                        </div>

                        <div className="col-6">
                            <label className="fw-bold">Date/Time</label>
                            <p>{toNullableLocaleDateTimeString(props.shipmentUpdate.updateTime)}</p>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-6">
                            <label className="fw-bold">Status</label>
                            <p>{props.shipmentUpdate.shipmentStatus}</p>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        className='btn btn-default'
                        onClick={() => props.setShow(false)}>
                        Close
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export const ButtonLoadingSpinner = () => {
    return (
        <div className="spinner-border spinner-border-sm text-default" role="status">
            <span className="visually-hidden">Loading...</span>
        </div>
    );
};